import { AgedARReport } from "./AgedARReport";
import { AutogenLayoutAgedARResponsibilityReport } from "./autogen/AutogenLayoutAgedARResponsibilityReport";

export class AgedARResponsibilityReport extends AutogenLayoutAgedARResponsibilityReport {

    onLoad() {
        const layout = this.layoutReport as AgedARReport;
        layout.isResponsibility = true;
        this.mainDataSource = layout.mainDataSource;
    }
}
